module.exports = __webpack_public_path__ + "static/media/createPrototype.17b382de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/steps/createPrototype.svg
// module id = 402
// module chunks = 0